import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { createFormStepAsync, updateFormStepAsync, deleteFormStepAsync, getFormStepByIdAsync, getFormStepsByEventIdAsync } from './formStepsThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const formStepsSlice = createSlice({
    name: 'formSteps',
    initialState,
    reducers: {
        clearFormStep: (state) => {
            state.formStep = undefined;
        },
        clearFormSteps: (state) => {
            state.formSteps = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(createFormStepAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createFormStepAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.formStep = action.payload;
        })
            .addCase(createFormStepAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateFormStepAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateFormStepAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.formStep = action.payload;
        })
            .addCase(updateFormStepAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteFormStepAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteFormStepAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(deleteFormStepAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getFormStepByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getFormStepByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.formStep = action.payload;
        })
            .addCase(getFormStepByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getFormStepsByEventIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getFormStepsByEventIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.formSteps = action.payload;
        })
            .addCase(getFormStepsByEventIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { clearFormStep, clearFormSteps } = formStepsSlice.actions;
export default formStepsSlice.reducer;
